<script>
	import Loading from "@/components/layout/Loading.vue";
	import moment from 'moment';
	export default {
		props: {
			data: {
				type: Array,
				required: true
			},
			loading: {
				type: Boolean,
				required: true
			}
		},
		components: {
			Loading
		},
		methods: {
			formatoFecha(fecha){
				try{
					return moment(fecha).format('DD/MM/YYYY');
				}catch(error){
					console.log("falla formatoFecha, error: ", error);
				}
				
			}
		}
	}
</script>
<template>
	<section class="list-solicitudes">
		<Loading
			v-if="loading"
			pixeles="100px"
			class="mb-3"
		/>
		<ul 
			v-if="!loading"
			class="list-group list-group-flush">
			<li 
				v-for="item in data" :key="item.id"
				class="list-group-item d-flex align-items-center justify-content-between">
				<p class="text-secondary mb-0">
					{{ item.tipo_solicitud.nombre_solicitud }} - {{ formatoFecha(item.fecha_creacion) }}
				</p> 
				<span class="d-flex align-items-center justify-content-between fs-6 badge border text-secondary">
					<span class="circle-text me-2" :style="`background-color: ${item.estado_solicitud.color};`"></span>
					{{ item.estado_solicitud.nombre }}
				</span>
			</li>
		</ul>
	</section>
</template>
